import { gql } from '@apollo/client'

export const ProjectContactFragment = gql`
  fragment ProjectContactFragment on ProjectContact {
    id
    role
    fullName
    companyName
    address
    zipCode
    phone
    email
    city
    order
  }
`
